/**
 * @param {{ plan: string, status: string; paid: boolean }} billing Workspace billing
 * @param {boolean} [allowPastDue] Allow paid functionality if status is 'past_due'
 * @returns {boolean} True, if paid functionality access should be allowed
 */
export const isPaid = (billing, allowPastDue = false) => {
    const { plan, status, paid } = billing;

    if (plan && (status === 'trialing' || plan === 'basic' || plan === 'unlimited')) {
        return true;
    }

    return paid || (allowPastDue && status === 'past_due');
};

/**
 * @param {{ plan, status, paid }} billing Workspace billing
 * @param {boolean} [allowPastDue] Allow paid functionality if status is 'past_due'
 * @returns {boolean} True, if paid functionality access should be forbidden
 */
export const isBasic = (billing, allowPastDue = false) => billing.plan === 'basic' || !isPaid(billing, allowPastDue);
